/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Coinvestments_Report_Reportinghistory_Lastupdated3Inputs */

const en_coinvestments_report_reportinghistory_lastupdated3 = /** @type {(inputs: Coinvestments_Report_Reportinghistory_Lastupdated3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated ${i?.period}`)
};

/**
* | output |
* | --- |
* | "Last updated {period}" |
*
* @param {Coinvestments_Report_Reportinghistory_Lastupdated3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_reportinghistory_lastupdated3 = /** @type {((inputs: Coinvestments_Report_Reportinghistory_Lastupdated3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Reportinghistory_Lastupdated3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_reportinghistory_lastupdated3(inputs)
});
export { coinvestments_report_reportinghistory_lastupdated3 as "coInvestments_report_reportingHistory_lastUpdated" }